export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDjtfNlxjDCnBMib18LleE6bNxMACEpdIk',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'pay888.app',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'pay888app',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'pay888app.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '323268792585',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:323268792585:web:49cbd6fd5cfa83956ac3d8',
};

export function isFirebaseConfigured(): boolean {
  return Boolean(firebaseConfig.projectId) && firebaseConfig.projectId !== 'YOUR_PROJECT_ID';
}
